<script>
    import PatientQuoteNotes from "./components/PatientQuoteNotes.svelte";
    import PatientQuotePatientNotes from "./components/PatientQuotePatientNotes.svelte";

    export let patientID;
    export let patientHasNotes = false;
    export let encounterID;
    export let encounterHasNotes = false;
    export let reloadPatientDetails = () => {};
</script>

<div class="relative flex-1">
    <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 mt-4">
        <PatientQuotePatientNotes
            {patientID}
            {patientHasNotes}
            {reloadPatientDetails}
        />

        <PatientQuoteNotes
            {encounterID}
            {encounterHasNotes}
            {reloadPatientDetails}
        />
    </div>
</div>
